import { RolloutProgressReportEntities } from '../../shared/self-inspection-reports/service/entities';
import {
  DistributionPointProperties,
  PointType,
} from '../span-progress-entities';

export type ReportFilterType = Exclude<
  RolloutProgressReportEntities.v3.MarkerTypes,
  RolloutProgressReportEntities.v3.MarkerTypes.CABINET_NEW
>;

const reportTypeByPointType: Partial<Record<PointType, ReportFilterType>> = {
  [PointType.Hp]: RolloutProgressReportEntities.v3.MarkerTypes.HP,
  [PointType.Hc]: RolloutProgressReportEntities.v3.MarkerTypes.HC,
  [PointType.CableWell]: RolloutProgressReportEntities.v3.MarkerTypes.MANHOLE,
  [PointType.SlingWell]: RolloutProgressReportEntities.v3.MarkerTypes.MANHOLE,
  [PointType.Cabinet]: RolloutProgressReportEntities.v3.MarkerTypes.CABINET,
  [PointType.JointBox]: RolloutProgressReportEntities.v3.MarkerTypes.CABINET,
  [PointType.Site]: RolloutProgressReportEntities.v3.MarkerTypes.SITE,
  [PointType.Hub]: RolloutProgressReportEntities.v3.MarkerTypes.HUB,
};

export function getReportablePointType(
  properties: DistributionPointProperties,
): ReportFilterType | undefined {
  return reportTypeByPointType[properties.markerTypeId as PointType];
}

export function getReportForMarker(
  reports: RolloutProgressReportEntities.v3.ReportsByMarkerType,
  type: ReportFilterType,
  markerId: string,
): RolloutProgressReportEntities.v3.ReportResponse | undefined {
  if (type === RolloutProgressReportEntities.v3.MarkerTypes.CABINET) {
    return reports.CABINET?.[markerId] ?? reports.CABINET_NEW?.[markerId];
  }

  if (type === RolloutProgressReportEntities.v3.MarkerTypes.SPAN) {
    return (
      reports.SPAN?.[markerId] ??
      Object.values(reports.SPAN ?? {}).find((report) =>
        report.spans?.includes(markerId),
      )
    );
  }

  return reports[type]?.[markerId];
}

export function findLinkedKp(
  point: DistributionPointProperties | undefined,
  hpMarkerId: string,
  matchLinkedLeadIdOnly = false,
): DistributionPointProperties | undefined {
  if (!point) {
    return undefined;
  }

  const isLinkedKp =
    point.markerTypeId === PointType.DuctPoint &&
    point.linkedFtthMarkers?.some(
      (linkedPoint) =>
        linkedPoint.leadId === hpMarkerId ||
        (!matchLinkedLeadIdOnly && linkedPoint.sourceKey === hpMarkerId),
    );
  if (isLinkedKp) {
    return point;
  }

  return (point.aggregatedMarkerReferences ?? [])
    .map((reference) =>
      findLinkedKp(reference, hpMarkerId, matchLinkedLeadIdOnly),
    )
    .find((linkedKp) => linkedKp !== undefined);
}
